<template>
  <table class="table table-google w-100">
    <tbody>
      <tr>
        <td>Status</td>
        <td>
          <button-select v-model="value.candle_status" :options="options.candle_status" size="sm" />
        </td>
      </tr>
      <tr>
        <td>Brand</td>
        <td>
          <v-select
            v-model="value.competitor_brand_id"
            :options="dropdowns.competitor_brand"
            size="sm"
            label="text"
            :reduce="option => option.value"
            class="w-100"
          />
        </td>
      </tr>
      <tr>
        <td>Name</td>
        <td>
          <b-form-input
            v-model="value.candle_name"
            size="sm"
            autocomplete="off"
            trim
          />
        </td>
      </tr>

      <tr>
        <td>Fragrance</td>
        <td>
          <b-form-input
            v-model="value.candle_fragrance"
            size="sm"
            autocomplete="off"
            trim
          />
        </td>
      </tr>

      <tr>
        <td>Size</td>
        <td>
          <b-form-input
            v-model="value.candle_size"
            size="sm"
            autocomplete="off"
            trim
          />
        </td>
      </tr>

      <tr>
        <td>Note</td>
        <td>
          <b-form-textarea
            id="textarea"
            v-model="value.candle_note"
            placeholder="Enter something..."
            rows="8"
            size="sm"
          ></b-form-textarea>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
const ButtonSelect = () => import('@/components/global/ButtonSelect.vue');
export default {
  name: 'CompetitorRecordDetails',
  components: {
    ButtonSelect,
  },
  computed: {
    dropdowns() {
      return this.$store.state.app.dropdowns;
    },
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: {
        candle_status: [
          { text: 'New', value: 'new' },
          { text: 'Burning', value: 'burning' },
          { text: 'Finished', value: 'finished' },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
